import { useQuery } from '@tanstack/react-query';
import { MdError } from 'react-icons/md';
import { toast } from 'react-toastify';
import ReactIcon from '../components/ReactIcon';
import {
    allTypeListCategory,
    parkTicketEnumKey,
    surfTicketEnumKey,
} from '../consts/typeListConst';
import { ProductTypeList } from '../services/salesShopItems.service';
import { useShoppingCartStore } from '../store/shoppingCart/shoppingCartStore';

export const useGetProductsTypeList = () => {
    const { setTypesList } = useShoppingCartStore();

    const { isPending, data } = useQuery({
        queryKey: ['productTypeList'],
        queryFn: async () => {
            // Type id 7 is type for waves
            const response = (await ProductTypeList())
                .filter(
                    ({ category }) =>
                        category.enumKey !== parkTicketEnumKey &&
                        category.enumKey !== surfTicketEnumKey
                )
                .sort((a, b) => a.orderBy - b.orderBy)
                .concat([allTypeListCategory]);
            setTypesList(response);
            return response;
        },
        throwOnError: () => {
            toast.error(() => 'Erro ao atualizar os tipos dos produtos', {
                toastId: 5,
                style: {
                    fontSize: '1rem',
                    fontWeight: '400',
                },
                position: 'top-right',
                autoClose: 5000,
                icon: (
                    <ReactIcon
                        Icon={MdError}
                        size={'1.5rem'}
                        fill="#e40505"
                        color="white"
                    />
                ),
            });
            return false;
        },
    });

    return {
        isPending,
        data,
    };
};
